import { z } from 'zod';

export const LoanRemittanceSettingsApi = z.object({
  id: z.string(),
  loanId: z.string(),
  losId: z.string(),
  remittanceSettings: z.array(
    z.object({
      startDate: z.iso.datetime(),
      soldDate: z.iso.datetime().optional(),
      investorAOwnership: z.number().nonnegative(),
      investorBOwnership: z.number().nonnegative(),
      soldRate: z.number().nonnegative(),
      soldRateB: z.number().nonnegative(),
      stripRate: z.number().nonnegative(),
      ownerId: z.string(),
      poolId: z.string(),
    }),
  ),
});
export type LoanRemittanceSettingsApi = z.infer<typeof LoanRemittanceSettingsApi>;
